import React from "react";

const CptShimmerBlock = ({ className = "", as: Tag = "div", ...props }) => (
  <Tag className={`mpr-shimmer-card ${className}`.trim()} {...props} />
);

export default CptShimmerBlock;
